import {Color, Data, PctDouble, RecordProps, Seconds} from '@store/@types/util';
import {UserId} from 'records/User';
import {Set, Map} from 'immutable';
import customTheme from 'styles/theme';

export enum CommentColor {
  ORANGE = '#FF8655',
  GREEN = '#69F0AE',
  RED = '#FF4081',
  BLUE = '#536DFE',
}
const colors: Set<string> = Set(Object.values(CommentColor));

const oldColorToNewColor = Map<string | undefined, CommentColor>()
  .set(customTheme.palette.highlight1Color, CommentColor.RED)
  .set(customTheme.palette.highlight2Color, CommentColor.ORANGE)
  .set(customTheme.palette.highlight3Color, CommentColor.ORANGE)
  .set(customTheme.palette.highlight4Color, CommentColor.ORANGE)
  .set(customTheme.palette.highlight5Color, CommentColor.GREEN)
  .set(customTheme.palette.highlight6Color, CommentColor.BLUE);

// Invalid colors default to orange
const getColor = (color: string | undefined) => {
  // First check if the color is one of our enum values
  // If it isn't, check if we have a mapping from the old colors to the new colors
  // If we don't, return the default Orange
  return colors.has(color)
    ? (color as CommentColor)
    : oldColorToNewColor.has(color)
    ? oldColorToNewColor.get(color)
    : CommentColor.ORANGE;
};

export type CommentId = string;
interface CommentInterface {
  id?: CommentId;
  message: string;
  startTime: Seconds;
  endTime: Seconds;
  taggedUsers?: UserId[];
  color?: CommentColor;
  author: {
    userId: UserId;
    firstName: string;
    lastName: string;
    color: Color;
  };

  /* @deprecated */
  location: PctDouble;
  /* @deprecated - use userId under `author` */
  userId: UserId;
}

interface LegacyProps {
  user_id: string;
}

interface HighlightProps {
  start: Seconds;
  end: Seconds;
}

/**
 * TODO needs to be simplified to interact with a single API style
 */
export class UserComment extends Data<CommentInterface>({
  id: undefined,
  message: undefined,
  author: undefined,
  location: undefined,
  startTime: undefined,
  endTime: undefined,
  taggedUsers: undefined,
  userId: undefined,
  color: undefined,
}) {
  constructor(props: RecordProps<CommentInterface & LegacyProps & HighlightProps>, duration = 1) {
    // location comes in as seconds, but old components expect a PctDouble
    const pctLocation = props.location! / duration;
    super({
      ...props,
      userId: props.userId || props.user_id,
      location: isNaN(pctLocation) ? undefined : pctLocation,
      color: getColor(props.color),
    });
  }

  isRange() {
    return this.startTime !== this.endTime;
  }
}
